import { jwtDecode } from "jwt-decode";

const AUTH_KEYS = {
  token: "token",
  accessToken: "access_token",
  refresh: "refresh",
  refreshToken: "refresh_token",
  role: "user_role",
  roleAlt: "auth_role",
};

const normalizeRole = (value) => {
  if (!value) return null;

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  if (normalized.includes("admin")) return "admin";
  if (normalized.includes("doctor")) return "doctor";
  if (normalized.includes("patient")) return "patient";
  return normalized;
};

export const getDecodedToken = () => {
  const token = getStoredToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const getStoredAuthRole = () => {
  if (typeof window === "undefined") return null;

  const storedRole = sessionStorage.getItem(AUTH_KEYS.role) || sessionStorage.getItem(AUTH_KEYS.roleAlt);
  if (storedRole) {
    return normalizeRole(storedRole);
  }

  const decoded = getDecodedToken();
  if (!decoded) return null;

  const roleFromPayload = decoded.role || decoded.user_type || decoded.userRole || decoded.role_name || decoded.user_role;
  if (roleFromPayload) {
    return normalizeRole(roleFromPayload);
  }

  if (decoded.admin_id || decoded.is_admin) {
    return "admin";
  }

  if (decoded.doctor_id) {
    return "doctor";
  }

  if (decoded.Patient_id || decoded.patient_id || decoded.user_id) {
    return "patient";
  }

  return null;
};

export const saveAuthSession = ({ token, refresh, role }) => {
  if (typeof window === "undefined") return;

  const normalizedRole = normalizeRole(role);
  const accessToken = token || getStoredToken();
  const refreshToken = refresh || sessionStorage.getItem(AUTH_KEYS.refresh) || sessionStorage.getItem(AUTH_KEYS.refreshToken) || "";

  sessionStorage.setItem(AUTH_KEYS.token, accessToken);
  sessionStorage.setItem(AUTH_KEYS.accessToken, accessToken);
  sessionStorage.setItem(AUTH_KEYS.refresh, refreshToken);
  sessionStorage.setItem(AUTH_KEYS.refreshToken, refreshToken);

  if (normalizedRole) {
    sessionStorage.setItem(AUTH_KEYS.role, normalizedRole);
    sessionStorage.setItem(AUTH_KEYS.roleAlt, normalizedRole);
  }
};

export const clearAuthSession = () => {
  if (typeof window === "undefined") return;

  Object.values(AUTH_KEYS).forEach((key) => sessionStorage.removeItem(key));
};

export const getStoredToken = () => {
  if (typeof window === "undefined") return "";
  return (
    sessionStorage.getItem(AUTH_KEYS.accessToken) ||
    sessionStorage.getItem(AUTH_KEYS.token) ||
    ""
  );
};

export const isAuthenticated = () => Boolean(getStoredToken());

export const getDashboardRoute = (role) => {
  switch (normalizeRole(role)) {
    case "admin":
      return "/admin/dashboard";
    case "doctor":
      return "/dashboard";
    case "patient":
      return "/patient-dashboard";
    default:
      return "/login";
  }
};

export const getLoginRoute = (role) => {
  if (normalizeRole(role) === "admin") {
    return "/admin";
  }
  return "/login";
};
